import { render, staticRenderFns } from "./SpotOrdersQuickView.vue?vue&type=template&id=15e54d30&scoped=true&"
import script from "./SpotOrdersQuickView.vue?vue&type=script&lang=js&"
export * from "./SpotOrdersQuickView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e54d30",
  null
  
)

export default component.exports